/* PERSIAN Experience v4 — scroll reveal + glass header. Vanilla JS, no cursor effects. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, cfg = window.PERSIAN_XP || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* Glass header state */
  var ticking = false;
  function onScroll() { root.classList.toggle('px-scrolled', window.scrollY > 24); ticking = false; }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();


  /* Hero intro class + scroll progress */
  if (!reduce && !designMode) {
    if (cfg.hero) root.classList.add('px-hero-in');
    if (cfg.progress) {
      var pr = doc.createElement('div'); pr.className = 'px-progress'; pr.innerHTML = '<i></i>'; doc.body.appendChild(pr);
      var bar = pr.firstChild, pt = false;
      var upd = function () { var h = Math.max(1, root.scrollHeight - window.innerHeight); bar.style.transform = 'scaleX(' + Math.min(1, window.scrollY / h) + ')'; pt = false; };
      window.addEventListener('scroll', function () { if (!pt) { pt = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
    }
  }

  /* Scroll reveal */
  if (!cfg.reveal || reduce || designMode || !('IntersectionObserver' in window)) return;
  root.classList.add('px-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.05, rootMargin: '0px 0px -3% 0px' });

  function mark(el, delay) {
    var anc = el.closest('[data-px-reveal]');
    if (el.hasAttribute('data-px-reveal') || (anc && anc !== el)) return;
    el.setAttribute('data-px-reveal', '');
    if (delay) el.style.setProperty('--px-delay', delay + 'ms');
    io.observe(el);
  }

  function splitHeading(el) {
    if (el.dataset.pxSplit) return; el.dataset.pxSplit = '1';
    var w = doc.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n, i = 0;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) nodes.push(n); }
    nodes.forEach(function (node) {
      var frag = doc.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (t) {
        if (!t) return;
        if (/^\s+$/.test(t)) { frag.appendChild(doc.createTextNode(' ')); return; }
        var o = doc.createElement('span'); o.className = 'px-split-word';
        var s = doc.createElement('span'); s.textContent = t; s.style.setProperty('--px-delay', (i++ * 30) + 'ms');
        o.appendChild(s); frag.appendChild(o);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }
  function scan(scope) {
    var secs = scope.querySelectorAll ? scope.querySelectorAll('main .shopify-section') : [];
    Array.prototype.forEach.call(secs, function (s, i) { if (i > 0) mark(s, 0); });
    Array.prototype.forEach.call(scope.querySelectorAll('main product-card, main .collection-card'), function (c) {
      var i = c.parentElement ? Array.prototype.indexOf.call(c.parentElement.children, c) : 0;
      mark(c, Math.min(i, 5) * 30);
    });
    if (cfg.headings) Array.prototype.forEach.call(scope.querySelectorAll('main h2, main .h2'), function (h) {
      if (h.closest('.shopify-section:first-child') || h.children.length > 3 || h.textContent.length > 80 || h.dataset.pxSplit) return;
      splitHeading(h); h.classList.add('px-line'); io.observe(h);
    });
  }
  scan(doc);
  new MutationObserver(function (m) {
    m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(doc.querySelector('main') || doc.body, { childList: true, subtree: true });

  /* Safety net: never leave anything hidden */
  setTimeout(function () {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-px-reveal]:not(.is-in)'), function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });
  }, 1500);
})();
